<template>

  <div class="pa-6 container">

    <!-- Query Parameter -->
    <LayoutQueryParameterPane
      class       = "query-param"
      :layout     = "layout"
      @reset      = "onReset"
    >
    </LayoutQueryParameterPane>
    
    <!-- Preview -->
    <LayoutPreviewPane 
      class       = "preview"
      :layout     = "layout"
    >
    </LayoutPreviewPane>

    <!-- Options -->
    <LayoutOptionsPane 
      class     = "options"
      :layout   = "layout"
    >
    </LayoutOptionsPane>

    <SnacksPane></SnacksPane>

  </div>

</template>

<script>

// #region Imports

/* Telestream */
import LayoutPreviewPane from '../components/panes/components/layout/LayoutPreviewPane.vue';
import LayoutOptionsPane from '../components/panes/components/layout/LayoutOptionsPane.vue';
import LayoutQueryParameterPane from '../components/panes/components/layout/LayoutQueryParameterPane.vue';
import SnacksPane from '../components/panes/components/SnacksPane.vue';

// #endregion Imports

// #region Constants

const DEFAULT_LAYOUT = {
  header: {
    visible: true
  },
  fileToolbar: {
    visible: true,
    actions: {
      watchers: true,
      cliplink: true,
      close:    true,
      browse:   true,
      history:  true
    }
  },
  videoPlayer: {
    visible: true
  },
  timeline: {
    visible: true
  },  
  topTabs: {
    visible: true,
    locked:  false,
    tabs:    ['Audio', 'Clips', 'Frame']
  },
  bottomTabs: {
    visible: true,
    locked:  false,
    tabs:    ['Inspector', 'Plugins']
  }
};

// #endregion Constants

export default {

  // #region Properties

  data() {
    return {
      layout: JSON.parse(JSON.stringify(DEFAULT_LAYOUT))
    }
  },
  components: {
    LayoutOptionsPane,
    LayoutPreviewPane,
    LayoutQueryParameterPane,
    SnacksPane
  },

  // #endregion Properties

  // #region Methods

  methods: {

    onReset() {
      this.layout = JSON.parse(JSON.stringify(DEFAULT_LAYOUT));
    }

  }

  // #endregion Methods

}

</script>

<style scoped lang="scss">

.container {
  width:        65vw;
  margin:       auto;

  display:      grid;
  gap:          32px;
  grid-template-columns: 1fr auto;

  .query-param {
    grid-column: 1 / 3;
  }
}

</style>